import { Component, input } from '@angular/core';
import type { OnyxScheduleCompliance } from '@onyx/angular';
import { OnyxIconComponent } from '@onyx/angular';
import type { RouteContext } from '../../../../../interfaces/route/route-context';

@Component({
  selector: 'app-route-point-leg-ride',
  imports: [OnyxIconComponent],
  templateUrl: './route-point-leg-ride.component.html',
  styleUrl: './route-point-leg-ride.component.scss',
  host: {
    '[class]': `compliance()`,
    '[class.animation]': `context() === 'order'`,
    '[style.top.%]': `legProgressPercentage()`,
  },
})
export class RoutePointLegRideComponent {
  public readonly compliance = input.required<OnyxScheduleCompliance | null>();
  public readonly context = input.required<RouteContext>();
  public readonly legProgressPercentage = input(50);
}
